import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import HrmsDemo from "./pages/demo/HrmsDemo";
import BookingDemo from "./pages/demo/BookingDemo";
import WorkhubDemo from "./pages/demo/WorkhubDemo";
import TravelDemo from "./pages/demo/TravelDemo";
import FinanceDemo from "./pages/demo/FinanceDemo";
import ShopDemo from "./pages/demo/ShopDemo";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/demo/hrms" element={<HrmsDemo />} />
            <Route path="/demo/booking/*" element={<BookingDemo />} />
            <Route path="/demo/workhub" element={<WorkhubDemo />} />
            <Route path="/demo/travel" element={<TravelDemo />} />
            <Route path="/demo/finance" element={<FinanceDemo />} />
            <Route path="/demo/shop" element={<ShopDemo />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
